import { render } from "./HelloWorld.vue?vue&type=template&id=ebbc34ee&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=ebbc34ee&scoped=true&lang=css"

import exportComponent from "/home/kadek/belajar/kadek-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebbc34ee"]])

export default __exports__